import { StopNotesAndReferenceNumbers } from "../StopNotesAndReferenceNumbers";
import { CityState, DataSource, Label, Layout, Location, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStopEntry extends Layout {
    citystateCityStateZip: CityState;
    labelAdditionalStopDetails: Label;
    labelBetween: Label;
    layoutStopNotesAndRefNbrs: StopNotesAndReferenceNumbers;
    locationLocation: Location;
    orderSource: DataSource;
    panelActualTimes: Panel;
    panelAdditionalDetails: Panel;
    panelDropTrailer: Panel;
    panelLateArrival: Panel;
    panelLocation: Panel;
    panelStopCommentsReferenceNumbers: Panel;
    sourceStop: DataSource;
    textboxActualArrival: Textbox;
    textboxActualDeparture: Textbox;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxAppointmentStatusId: Textbox;
    textboxCases: Textbox;
    textboxContactEmail: Textbox;
    textboxContactName: Textbox;
    textboxContactPhone: Textbox;
    textboxLocationId: Textbox;
    textboxLocationName: Textbox;
    textboxPickupDate: Textbox;
    textboxSchedArriveEarly: Textbox;
    textboxSchedArriveLate: Textbox;
    textboxStopType: Textbox;
    textboxVolume: Textbox;
    textboxWeight: Textbox;
    textboxZoneId: Textbox;
}
